import * as themeConstants from '../../Constants/Theme/Theme.constants';

/**
 * Create styles for `<ConfirmMobileNumberModal />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<ConfirmMobileNumberModal />` styles
 */
const confirmMobileNumberModalStyles = ({ theme }) => ({
  paperClasses: {
    maxHeight: `40%`,
    maxWidth: 400,
  },
  phoneNumber: {
    color: themeConstants.BORAL_GREEN,
    paddingTop: theme.spacing(1) * 2,
    paddingBottom: theme.spacing(1) * 2,
  },
});

export default confirmMobileNumberModalStyles;
